// extracted by mini-css-extract-plugin
export default {"title":"title--JQ274","icon":"icon--tDsTn"};